export default __webpack_public_path__ + "static/media/dashboard2.9fcdb486.gif";